import React from "react";
import TextInfo from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";

const Title = ({ title, background, link }) => {
  return (
    <div className="container-custom-title">
      {link && (
        <CustomLink
            {...link}
            title={link.title || ""}
            className="link-title"
            taggingInfo={{
              componentName: "custom-title",
              componentContent: link.title,
              componentProduct: title.text || "",
              componentVariation: "all",
              eventType: "click",
            }}
            cyData="Title CustomLink-2"
        ></CustomLink>
      )}
      <div className="custom-title">
        <TextInfo {...title} size="t5" cyData="Title Text" />
      </div>
      <style jsx>{`
        .container-custom-title {
          position: relative;
          :global(.link-title) {
            z-index: 1;
          }
          &:hover {
            cursor: pointer;
          }
          .custom-title {
            background-color: ${background};
            border-radius: 8px;
            padding: .6rem 1.5rem;
            margin-bottom: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Title;
